import HelloWorld from './HelloWorld';
import Links1 from './Links1';
import Links2 from './Links2';
import WhatIsAnAIAgentFramework from './WhatIsAnAIAgentFramework';
import { toArticle } from './Post';

export type { Post } from './Post';
export { PostComponent } from './Post';

export type T = ReturnType<typeof toArticle>;

const _AllArticles: T[] = [
  HelloWorld,
  Links1,
  Links2,
  WhatIsAnAIAgentFramework,
].map(toArticle);

export const All = _AllArticles.sort((x, y) => x.postedAt.getTime() - y.postedAt.getTime()).reverse();
